var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FLOOD_RISK, MapLayers } from "./interface";
import { pathOr } from "ramda";
const floodRiskChanceToLayer = {
    [FLOOD_RISK.VERY_LOW]: "1 in 1250 year flood",
    [FLOOD_RISK.LOW]: "1 in 500 year flood",
    [FLOOD_RISK.MEDIUM]: "1 in 100 year flood",
    [FLOOD_RISK.HIGH]: "1 in 20 year flood",
    [FLOOD_RISK.VERY_HIGH]: "1 in 5 year flood"
};
export default class MapViewService {
    constructor() {
        this.higlightedFeature = undefined;
        this.selectedFeature = undefined;
        this.selectedLayer = undefined;
        this.graphicsLayer = undefined;
        this.blinkLayer = undefined;
        this.blinkFrameAnimation = null;
        this.blinkCount = 0;
    }
    findFloodLayer(floodRiskValue) {
        if (!this.mapView) {
            throw new Error("Map view not ready");
        }
        return this.mapView.map.layers.items.find((l) => l.title === floodRiskChanceToLayer[floodRiskValue]);
    }
    setMapView(mapView) {
        try {
            if (!this.selectedLayer) {
                const lowFloodTileLayer = mapView.map.allLayers.find(l => l.title === MapLayers.LOW);
                lowFloodTileLayer.visible = false;
            }
            const boundaryLayer = mapView.map.allLayers.find(l => l.title === MapLayers.BOUNDARY);
            boundaryLayer.outFields = ["*"];
            const graphicsLayer = mapView.map.allLayers.find(l => l.title === MapLayers.GRAPHICS);
            this.graphicsLayer = graphicsLayer;
            mapView.whenLayerView(boundaryLayer).then(() => {
                const blinkLayer = mapView.map.allLayers.find(l => l.title === MapLayers.BLINK);
                this.blinkLayer = blinkLayer;
                this.blinkLayer.visible = false;
                //this.loadBlinkFeature();
            });
            this.mapView = mapView;
        }
        catch (e) {
            console.error(e);
        }
    }
    getMapView() {
        return this.mapView;
    }
    isReady() {
        return !!this.mapView;
    }
    findLayer(layerTitle) {
        return new Promise((resolve, reject) => {
            if (!this.mapView) {
                return reject("Map view not ready");
            }
            this.mapView.when(() => {
                if (this.mapView) {
                    const layer = this.mapView.map.allLayers.items.find((l) => l.title === layerTitle);
                    resolve(layer);
                }
            });
        });
    }
    isFloodLayerVisible(floodRiskValue) {
        if (!this.mapView) {
            throw new Error("Map view not ready");
        }
        const layer = this.findFloodLayer(floodRiskValue);
        if (layer) {
            if (layer.visible) {
                this.selectedLayer = layer;
            }
            return layer.visible;
        }
    }
    setVisibleFloodLayer(floodRiskValue) {
        if (!this.mapView) {
            throw new Error("Map view not ready");
        }
        this.mapView.map.layers.items.forEach((l) => {
            if (l.title.includes("flood")) {
                l.visible = false;
            }
        });
        const layer = this.findFloodLayer(floodRiskValue);
        if (layer) {
            layer.visible = true;
            this.selectedLayer = layer;
        }
    }
    getVisibleFloodLayer() {
        if (this.selectedLayer) {
            return {
                layer: this.selectedLayer,
                key: Object.keys(floodRiskChanceToLayer).find(key => this.selectedLayer &&
                    floodRiskChanceToLayer[key] === this.selectedLayer.title)
            };
        }
    }
    focusOnFeature(feature, featureLayer, isMobile) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.mapView) {
                throw new Error("Map view not ready");
            }
            const layerView = yield this.mapView.whenLayerView(featureLayer);
            this.higlightedFeature && this.higlightedFeature.remove();
            yield this.mapView.goTo({
                target: feature
            });
            if (isMobile) {
                let screenCoordinate = this.mapView.toScreen(this.mapView.center);
                const newCenter = this.mapView.toMap(Object.assign(Object.assign({}, screenCoordinate), { y: screenCoordinate.y - 150 }));
                yield this.mapView.goTo({
                    center: [newCenter.longitude, newCenter.latitude]
                });
            }
            this.higlightedFeature = layerView.highlight(feature);
            if (this.graphicsLayer) {
                this.graphicsLayer.removeAll();
                if (feature.geometry.type === "point") {
                    this.graphicsLayer.add(feature);
                }
            }
            this.selectedFeature = feature;
            // this.loadBlinkFeature();
            return feature;
        });
    }
    unfocusFeature() {
        this.higlightedFeature && this.higlightedFeature.remove();
        if (this.graphicsLayer) {
            this.graphicsLayer.removeAll();
        }
        this.higlightedFeature = undefined;
        this.selectedFeature = undefined;
    }
    getAllLayers() {
        return new Promise((resolve, reject) => {
            if (!this.mapView) {
                return reject("Map view not ready");
            }
            this.mapView.when(() => {
                resolve(pathOr([], ["map", "allLayers", "items"], this.mapView));
            });
        });
    }
    // loadBlinkFeature() {
    //   this.blinkLayer?.removeAll();
    //   this.mapView?.map.layers.forEach(async item => {
    //     if (item.type === "feature") {
    //       let featureLayer: __esri.FeatureLayer = item as __esri.FeatureLayer;
    //       const query = {
    //         // autocasts as Query
    //         where: "AOI='IN'", // select sububrb that within the coverage
    //         returnGeometry: true,
    //         outFields: ["*"]
    //       };
    //       const results = await featureLayer.queryFeatures(query);
    //       const features = results.features;
    //       features.forEach(item => {
    //         if (
    //           this.selectedFeature &&
    //           item.attributes.OBJECTID ===
    //             this.selectedFeature.attributes.OBJECTID
    //         ) {
    //           return;
    //         }
    //         item.symbol = {
    //           type: "simple-fill", // autocasts as new SimpleFillSymbol()
    //           //@ts-ignore
    //           color: {
    //             r: 29,
    //             g: 59,
    //             b: 120,
    //             a: 0.5
    //           },
    //           style: "solid",
    //           outline: {
    //             color: "#fff",
    //             width: "5px"
    //           }
    //         };
    //         this.blinkLayer?.add(item);
    //       });
    //     }
    //   });
    // }
    // blinkFeatureLayer(center: __esri.Point) {
    //   const blink = () => {
    //     if (this.blinkLayer) {
    //       this.blinkLayer.visible = !this.blinkLayer.visible;
    //       setTimeout(() => {
    //         this.blinkFrameAnimation = window.requestAnimationFrame(blink);
    //         this.blinkCount += 1;
    //         if (this.blinkCount === 2) {
    //           window.cancelAnimationFrame(this.blinkFrameAnimation);
    //           if (this.blinkLayer) this.blinkLayer.visible = false;
    //           this.blinkCount = 0;
    //         }
    //       }, 500);
    //     }
    //   };
    //   window.cancelAnimationFrame(this.blinkFrameAnimation);
    //   if (this.blinkLayer) this.blinkLayer.visible = false;
    //   this.blinkCount = 0;
    //   this.blinkFrameAnimation = window.requestAnimationFrame(blink);
    // }
    getFeature(suburb, mapView) {
        return __awaiter(this, void 0, void 0, function* () {
            const suburbLayer = mapView === null || mapView === void 0 ? void 0 : mapView.map.layers.find(item => item.title === MapLayers.BOUNDARY);
            const query = {
                // autocasts as Query
                where: `Suburb='${suburb.toUpperCase()}'`,
                returnGeometry: true,
                outFields: ["*"]
            };
            const results = yield suburbLayer.queryFeatures(query);
            return results.features.length > 0 ? results.features.pop() : undefined;
        });
    }
}
